import { render, staticRenderFns } from "./projetoexterno.items.vue?vue&type=template&id=0589dc49&"
import script from "./projetoexterno.items.vue?vue&type=script&lang=js&"
export * from "./projetoexterno.items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports